// Function setItem / getItem / parseJSON local
function getItem(name) {
  return window.localStorage.getItem(name)
}

function parseJSON(item) {
  return JSON.parse(getItem(item))
}

// Variable
const user = {
  vgp_id: getItem('userId'),
  save: parseJSON('save'),
  game_id: getItem('game_id'),
  list: parseJSON('server_by_group'),
  server_name: getItem('server_name'),
  server_group: getItem('server_group'),
  character_name: getItem('character_name'),
}

// Function action
function action_giftcode_add(name) {
  this.$store.dispatch(name, {
    game_id: user.game_id,
    character_id: this.character_id,
    server_id: this.server_id,
    code: this.code_game !== '' ? this.code_game : this.code,
  })
}

function action_giftcode_add_value(name, value) {
  this.$store.dispatch(name, {
    game_id: value.game_id,
    character_id: value.character_id,
    server_id: value.server_id,
    code: this.code_game !== '' ? this.code_game : this.code,
  })
}

function action_giftcode_add_server(name, params) {
  this.$store.dispatch(name, {
    game_id: params.game_id,
    character_id: this.character_id,
    server_id: params.server_id,
    code: this.code_game !== '' ? this.code_game : this.code,
  })
}

function action_get_form_select(params) {
  this.selected = params.game_server
  this.group_server = params.server_group
  this.server = params.server_name
  this.character = params.character_name
}

// Function test case
function test_character_name(params) {
  if (user.character_name !== params.character_name) {
    this.action_giftcode_add_value('GIFTCODE_ADD', params)
  }

  if (user.character_name === params.character_name) {
    this.action_giftcode_add('GIFTCODE_ADD')
  }
}

function test_server_name(params) {
  if (user.server_name !== params.server_name) {
    this.action_giftcode_add('GIFTCODE_ADD')
  }

  if (user.server_name === params.server_name) {
    this.test_character_name(params)
  }
}

function test_server_group(params) {
  if (user.server_group !== params.server_group) {
    this.action_giftcode_add('GIFTCODE_ADD')
  }
  if (user.server_group === params.server_group) {
    this.test_server_name(params)
  }
}

function test_same_game_id(params) {
  if (user.game_id === params.game_id) {
    this.test_server_group(params)
  }
}

function test_game_id(same, other, value) {
  // Chỉ có cùng game_id
  if (same !== undefined && other !== undefined) {
    this.test_server_group(value)
  }
  // Có cả cùng game_id và khác game_id
  if (same !== undefined && other !== undefined) {
    this.test_same_game_id(value)
  }
  // Chỉ có khác game_id
  if (same === undefined && other !== undefined) {
    this.action_giftcode_add('GIFTCODE_ADD')
  }
}

function test_data(params) {
  if (params) {
    const sameGame = params.filter(id => id.game_id === user.game_id)
    const otherGame = params.filter(id => id.game_id !== user.game_id)
    params.forEach(element => {
      this.test_game_id(sameGame[0], otherGame[0], element)
    })
  }
}

function test_user_id(params) {
  if (params[0] !== undefined) {
    const data = params[0].data
    this.test_data(data)
  }
}

function test_save_user() {
  if (user.save !== null) {
    const getUser = user.save.filter(item => item.id === user.vgp_id)
    this.test_user_id(getUser)
  } else {
    this.action_giftcode_add('GIFTCODE_ADD')
  }
}

function action_save_user() {
  const saveUser = JSON.parse(window.localStorage.getItem('save'))
  const vgpId = window.localStorage.getItem('userId')
  const gameId = window.localStorage.getItem('game_id')
  const serverGroup = window.localStorage.getItem('server_group')
  const serverName = window.localStorage.getItem('server_name')
  const characterName = window.localStorage.getItem('character_name')
  if (saveUser !== null) {
    const getUser = saveUser.filter(item => item.id === vgpId)
    if (getUser[0] !== undefined) {
      const data = getUser[0].data
      if (data) {
        const sameGame = data.filter(id => id.game_id === gameId)
        const otherGame = data.filter(id => id.game_id !== gameId)
        data.forEach(element => {
          if (sameGame[0] !== undefined && otherGame[0] === undefined) {
            // Case 1: Chỉ có cùng game
            if (serverGroup !== element.server_group) {
              // Cùng game khác cụm
              this.$store.dispatch('GIFTCODE_ADD', {
                game_id: gameId,
                character_id: this.character_id,
                server_id: this.server_id,
                code: this.code_game !== '' ? this.code_game : this.code,
              })
            }

            if (serverGroup === element.server_group) {
              // Cùng game cùng cụm
              if (serverName !== element.server_name) {
                this.$store.dispatch('GIFTCODE_ADD', {
                  game_id: gameId,
                  character_id: this.character_id,
                  server_id: this.server_id,
                  code: this.code_game !== '' ? this.code_game : this.code,
                })
              }

              if (serverName === element.server_name) {
                this.$store.dispatch('GIFTCODE_ADD', {
                  game_id: element.game_id,
                  character_id: element.character_id,
                  server_id: element.server_id,
                  code: this.code_game !== '' ? this.code_game : this.code,
                })
              }
            }
          }

          if (sameGame[0] !== undefined && otherGame[0] !== undefined) {
            // Case 2: Cả cùng game cả khác game
            if (element.game_id === gameId) {
              // Chỉ lấy cùng game
              if (serverGroup !== element.server_group) {
                // Cùng game khác cụm
                this.$store.dispatch('GIFTCODE_ADD', {
                  game_id: gameId,
                  character_id: this.character_id,
                  server_id: this.server_id,
                  code: this.code_game !== '' ? this.code_game : this.code,
                })
              }

              if (serverGroup === element.server_group) {
                // Cùng game cùng cụm
                if (serverName !== element.server_name) {
                  this.$store.dispatch('GIFTCODE_ADD', {
                    game_id: gameId,
                    character_id: this.character_id,
                    server_id: this.server_id,
                    code: this.code_game !== '' ? this.code_game : this.code,
                  })
                }

                if (serverName === element.server_name) {
                  if (characterName === element.character_name) {
                    this.$store.dispatch('GIFTCODE_ADD', {
                      game_id: element.game_id,
                      character_id: element.character_id,
                      server_id: element.server_id,
                      code: this.code_game !== '' ? this.code_game : this.code,
                    })
                  }

                  if (characterName !== element.character_name) {
                    this.$store.dispatch('GIFTCODE_ADD', {
                      game_id: element.game_id,
                      character_id: this.character_id,
                      server_id: element.server_id,
                      code: this.code_game !== '' ? this.code_game : this.code,
                    })
                  }
                }
              }
            }
          }

          if (sameGame[0] === undefined && otherGame[0] !== undefined) {
            // Case 3: Chỉ có khác game
            this.$store.dispatch('GIFTCODE_ADD', {
              game_id: gameId,
              character_id: this.character_id,
              server_id: this.server_id,
              code: this.code_game !== '' ? this.code_game : this.code,
            })
          }
        })
      }
    }
  }

  if (saveUser === null) {
    this.$store.dispatch('GIFTCODE_ADD', {
      game_id: gameId,
      character_id: this.character_id,
      server_id: this.server_id,
      code: this.code_game !== '' ? this.code_game : this.code,
    })
  }
}

export {
  test_server_name,
  test_server_group,
  test_same_game_id,
  test_game_id,
  test_data,
  test_user_id,
  test_character_name,
  test_save_user,
  action_giftcode_add,
  action_giftcode_add_value,
  action_giftcode_add_server,
  action_save_user,
  action_get_form_select,
}
